import 'react-native-gesture-handler';
import React,{useState,useEffect} from 'react';
import { createDrawerNavigator,DrawerContentScrollView,DrawerItem } from '@react-navigation/drawer';
import { createStackNavigator } from '@react-navigation/stack';
import { NavigationContainer,CommonActions } from '@react-navigation/native';
import { DefaultTheme, Provider as PaperProvider,IconButton,Avatar, Divider } from 'react-native-paper';
import AsyncStorage from '@react-native-community/async-storage';
import persianDate from 'persian-date';
import {Image,View,Text,TouchableOpacity,Linking,I18nManager} from 'react-native';
import { useFonts } from 'expo-font';

import AboutScreen from './screens/about';
import ClassScreen from './screens/class';
import CommentsScreen from './screens/comments';
import FilterScreen from './screens/filter';
import InvoiceScreen from './screens/invoice';
import LoginScreen from './screens/login';
import MainScreen from './screens/main';
import SearchScreen from './screens/search';
import PlansScreen from './screens/plans';
import ProfileScreen from './screens/profile';
import RegisterScreen from './screens/register';
import SettingsScreen from './screens/settings';
import SplashScreen from './screens/splash';
import TermsScreen from './screens/terms';
import ValidationScreen from './screens/validation';
import WalkthroughScreen from './screens/walkthrough';
import EventsScreen from './screens/events';
import EditUser from './screens/edituser';

I18nManager.setPreferredLanguageRTL(true);

global.token = '';
global.fname = '';
global.lname = '';
global.gender = 0;
global.image = { uri:null };
global.mobile = '';
global.filters= {
  limit : 10,
  level : null,
  sports : [],
  facilities : {
    parking : false,
    locker : false,
    towel : false,
    pool : false
  },
  order : null,
  date: null,
  area:null,
  period:null
} ;
global.password = null;
global.credit = 0;
global.creditExpire = '-';

global.amount= null;
global.creditAmount=null;
global.authority = null;

global.activeClassInfo = null;
global.activeClassId = null;
global.acDate = new persianDate();
global.favorites = null;

global.forCanceling = null;


const theme = {
  ...DefaultTheme,
  roundness: 10,
  colors: {
    ...DefaultTheme.colors,
    primary: 'white',
    accent: '#ebebeb',
  },
  fonts:{
    regular: {
      fontFamily: 'iransans',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'iransansb',
      fontWeight: 'normal',
    },
    light: {
      fontFamily: 'iransans',
      fontWeight: 'normal',
    },
    thin: {
      fontFamily: 'iransans',
      fontWeight: 'normal',
    },
  }
};

const Drawer = createDrawerNavigator();
const LoginStack = createStackNavigator();
const PStack = createStackNavigator();
const SStack = createStackNavigator();
const MStack = createStackNavigator();

function CustomDrawerContent(props) {
  return (
    <DrawerContentScrollView {...props}>
      <Image style={{width:'100%',height:170,top:-55, position:'absolute'}} resizeMode='contain' source={require('./assets/drawerbg.png')} />
      <View style={{flexDirection:'row',alignItems:'center',marginLeft:15,marginTop:20}}>
      <Avatar.Image {...props}  size={48} source={{uri : global.image.uri}} />
      <Text style={{marginHorizontal:10,fontFamily:'iransansb',color:'white'}}>{global.fname+' '+global.lname}</Text>
      <IconButton icon='account-edit' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} color='white'
      onPress={()=>props.navigation.navigate('EditUser')} />
      </View>
      <View style={{flexDirection:'row', marginTop:50,marginHorizontal:20,justifyContent:'space-between',alignItems:'center'}}>
      <View style={{flexDirection:'row',alignItems:'center'}}>
      <IconButton icon='card-bulleted-outline' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-7}} />
      <Text style={{marginHorizontal:25,fontFamily:'iransans',fontSize:11}}>{global.credit+' '+'تومان'}</Text>
      </View>

      <TouchableOpacity style={{flexDirection:'row',alignItems:'center',backgroundColor:'#f2e5d7',borderRadius:15,paddingHorizontal:10,paddingVertical:2}}
      onPress={()=>props.navigation.navigate('Plans')}>
      <IconButton icon='plus' size={20} style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />
      <Text style={{marginLeft:25,marginRight:3,fontFamily:'iransansb', fontSize:9}}>تمدید اشتراک</Text>

      </TouchableOpacity>

      </View>
      <Divider style={{marginTop:15}}/>
      <DrawerItem label="صفحه اصلی" labelStyle={{fontFamily:'iransans', color:'#3a3635'}} icon={()=> <IconButton color='#3a3635' icon='home' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />} onPress={()=>{
          let resetAction = CommonActions.reset({
            index: 0,
            routes:[{name:'Main'},]
          });
          props.navigation.dispatch(resetAction);
       props.navigation.navigate('MainRoute')}} />
      <DrawerItem label="فعالیت های من" labelStyle={{fontFamily:'iransans', color:'#3a3635'}} icon={()=> <IconButton color='#3a3635' icon='account-circle' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />}  onPress={()=>{
                  let resetAction = CommonActions.reset({
                    index: 0,
                    routes:[{name:'Profile'},]
                  });
                  props.navigation.dispatch(resetAction);
                  props.navigation.navigate('ProfileRoute')
      }} />
      <DrawerItem label="فیت کارت" labelStyle={{fontFamily:'iransans', color:'#3a3635'}} icon={()=> <IconButton color='#3a3635' icon='card-bulleted' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />}  onPress={()=>props.navigation.navigate('Plans')} />
      <DrawerItem label="تنظیمات" labelStyle={{fontFamily:'iransans', color:'#3a3635'}} icon={()=> <IconButton color='#3a3635' icon='settings' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />}  onPress={()=>props.navigation.navigate('Settings')} />
      <DrawerItem label="درباره ما" labelStyle={{fontFamily:'iransans', color:'#3a3635'}} icon={()=> <IconButton color='#3a3635' icon='information' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />}  onPress={()=>props.navigation.navigate('About')} />
      <DrawerItem label="ارتباط با پشتیبانی" labelStyle={{fontFamily:'iransans', color:'#3a3635'}} icon={()=> <IconButton color='#3a3635' icon='phone' style={{marginRight:-25,marginLeft:-10, marginBottom:-5,marginTop:-5}} />}  onPress={()=> Linking.openURL('tel:09226346525')} />
    </DrawerContentScrollView>
  );
}

export default function App() {

  const[appState, setAppState]=useState('SplashScreen');
  let [fontsLoaded] = useFonts({
    'iransans': require('./assets/fonts/is.woff'),
    'iransansb': require('./assets/fonts/isb.woff'),
  });

  useEffect( () => {

    AsyncStorage.getItem('@auths').then( (value)=>{
      if(value !== null){
        let userData = JSON.parse(value);
        global.mobile = userData.mobile;

        try{
          
          fetch('https://fitwayz.ir/api/auth/login',
          {
            method:'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              mobile : userData.mobile,
              password : userData.pass,
              version: 2
            })
          }).then(response => response.json()).then(responseJson => {
            if(responseJson.result == 'success'){
              global.token = responseJson.token;
              global.fname = responseJson.user.fname;
              global.lname = responseJson.user.lname;
              global.gender = responseJson.user.gender == 'مرد' ? 0 : 1;
              global.image.uri = responseJson.user.image.replace('http','https');
              console.log(responseJson.user.image)
              setAppState('Main');
            } else{
              if(responseJson.code == '401.1'){
                setAppState('LoginStack')
              }
            }
          });

        }catch(e){
          console.log(e)
        }
      } else {
        setAppState('LoginStack');
      }
    });

  },[]); 

  function profileStack(){
    return(
      <PStack.Navigator screenOptions={{headerShown: false}} initialRouteName="Profile">
        <PStack.Screen name="Profile" component={ProfileScreen} />
        <PStack.Screen name="Class" component={ClassScreen} />
        <PStack.Screen name="Invoice" component={InvoiceScreen} />
        <PStack.Screen name="Comments" component={CommentsScreen} />
      </PStack.Navigator>

    )
  }

  function searchStack(){
    return(
      <SStack.Navigator screenOptions={{headerShown: false}} initialRouteName="Search">
        <SStack.Screen name="Search" component={SearchScreen} />
        <SStack.Screen name="Class" component={ClassScreen} />
        <SStack.Screen name="Invoice" component={InvoiceScreen} />
        <SStack.Screen name="Comments" component={CommentsScreen} />
        <SStack.Screen name="Filter" component={FilterScreen} />
      </SStack.Navigator>

    )
  }

  
  function mainStack(){
    return(
      <MStack.Navigator screenOptions={{headerShown: false}} initialRouteName="Main">
        <MStack.Screen name="Main" component={MainScreen} />
        <MStack.Screen name="Class" component={ClassScreen} />
        <MStack.Screen name="Invoice" component={InvoiceScreen} />
        <MStack.Screen name="Comments" component={CommentsScreen} />
      </MStack.Navigator>

    )
  }


  if (appState == 'SplashScreen' || !fontsLoaded ) {
    return (
      <SplashScreen/>
    );

  } else if (appState == 'LoginStack'){
    return (
      <PaperProvider theme={theme}>
      <NavigationContainer>
        <LoginStack.Navigator screenOptions={{headerShown: false}} initialRouteName="Walkthrough">
          <LoginStack.Screen name="Walkthrough" component={WalkthroughScreen} />
          <LoginStack.Screen name="Login" component={LoginScreen} />
          <LoginStack.Screen name="Validation">
          { props => <ValidationScreen {...props} changeAppState={setAppState}/> } 
          </LoginStack.Screen>
          <LoginStack.Screen name="Register">
          { props => <RegisterScreen {...props} changeAppState={setAppState}/> } 
          </LoginStack.Screen>
          <LoginStack.Screen name="Terms" component={TermsScreen} />
        </LoginStack.Navigator>
      </NavigationContainer>
      </PaperProvider>
    );

  } else {
  return (
   <PaperProvider theme={theme}>
   <NavigationContainer>
     <Drawer.Navigator initialRouteName="MainRoute" drawerContent={CustomDrawerContent}>
       <Drawer.Screen name="MainRoute" component={mainStack}/>
       <Drawer.Screen name="SearchRoute" component={searchStack}/>
       <Drawer.Screen name="ProfileRoute" component={profileStack} />
       <Drawer.Screen name="Plans" component={PlansScreen} />
       <Drawer.Screen name="About" component={AboutScreen} />
       <Drawer.Screen name="Events" component={EventsScreen} />
       <Drawer.Screen name="Settings" component={SettingsScreen} />
       <Drawer.Screen name="EditUser" component={EditUser} />
       <Drawer.Screen name="Terms" component={TermsScreen} />
     </Drawer.Navigator>
   </NavigationContainer>
   </PaperProvider>
  );
  }
}